export function roundNumber(number) {
    return Math.round((number + Number.EPSILON) * 10000) / 10000;
}
export function roundNumberToFloor(number) {
    return Math.floor((number + Number.EPSILON) * 10000) / 10000;
}
export function roundNumberToCeil(number) {
    return Math.ceil((number + Number.EPSILON) * 10000) / 10000;
}
export function stringToHex(str) {
    let hex = '';
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i).toString(16);
        hex += code.length < 2 ? '0' + code : code;
    }
    return '0x' + hex;
}
